const adminVideoRouter = [
  {
    path: '/admin/video',
    name: 'AdminVideoIndex',
    component: () => import('@/views/admin/video/index')
  },
  {
    path: '/admin/video/create',
    name: 'AdminVideoCreate',
    component: () => import('@/views/admin/video/create')
  },
  {
    path: '/admin/video/edit',
    name: 'AdminVideoEdit',
    component: () => import('@/views/admin/video/edit')
  },
  {
    path: '/admin/video/viewer',
    name: 'AdminVideoViewer',
    component: () => import('@/views/admin/video/viewer')
  }
]

export default adminVideoRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/video.js